import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUsecaseStructure } from '../../../../utils/CustomerUiAPI';

const UsecaseStructureContext = createContext();

export const useUsecaseStructure = () => {
  return useContext(UsecaseStructureContext);
};

export const UsecaseStructureProvider = ({ children }) => {
  const [structure, setStructure] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStructure = async () => {
    if (structure) return; // Use cached data if available
    
    setLoading(true);
    try {
      const response = await getUsecaseStructure();
      setStructure(response.response);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching usecase structure:', err);
    } finally {
      setLoading(false);
    }
  };

  const getBranches = () => {
    if (!structure) return [];
    return Object.keys(structure);
  };

  const getUsecases = (branch) => {
    if (!structure || !branch) return [];
    return Object.keys(structure[branch] || {});
  };

  const getSubusecases = (branch, usecase) => {
    if (!structure || !branch || !usecase) return [];
    return Object.keys(structure[branch]?.[usecase] || {});
  };

  return (
    <UsecaseStructureContext.Provider
      value={{
        structure,
        loading,
        error,
        fetchStructure,
        getBranches,
        getUsecases,
        getSubusecases,
      }}
    >
      {children}
    </UsecaseStructureContext.Provider>
  );
}; 